import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchApprovalDepartmentList = createAsyncThunk("fetchApprovalDepartmentList", async () => {
	try {
		const response = await axiosHttp.get(`approvals/department`);
		return response.data.data;
	} catch (error) {
		console.error("API Error:", error);
		throw error;
	}
});

const ApprovalDepartmentListSlice = createSlice({
	name: "ApprovalDepartmentListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchApprovalDepartmentList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchApprovalDepartmentList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchApprovalDepartmentList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ApprovalDepartmentListSlice.reducer;
